import { tokens } from '@/lib/tokens.js';
import type { ReactNode } from 'react';
import { Header } from './header.js';
import { Sidebar } from './sidebar.js';

interface AppShellProps {
  children: ReactNode;
  currentPath?: string;
}

export function AppShell({ children, currentPath }: AppShellProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        backgroundColor: tokens.colors.bgDark,
        color: tokens.colors.textDark,
        fontFamily: tokens.font.sans,
      }}
    >
      <Header />
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {currentPath !== undefined ? <Sidebar currentPath={currentPath} /> : <Sidebar />}
        <main
          id="main-content"
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: '1.5rem',
            backgroundColor: tokens.colors.bgDark,
          }}
        >
          {children}
        </main>
      </div>
    </div>
  );
}
